import { render, staticRenderFns } from "./PaymentFooter.vue?vue&type=template&id=a46c0448&scoped=true&"
import script from "./PaymentFooter.vue?vue&type=script&lang=js&"
export * from "./PaymentFooter.vue?vue&type=script&lang=js&"
import style0 from "./PaymentFooter.vue?vue&type=style&index=0&id=a46c0448&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a46c0448",
  null
  
)

export default component.exports